/* @flow */
import React from 'react';
import { Container } from 'flux/utils';
import Chat from 'entities/Chat';
import ChatStore from 'chat/stores/ChatStore';
import ChatList from 'chat/components/ChatList.jsx';
import ConversationView from 'chat/components/ConversationView.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import View from 'components/View.jsx';
import Group from 'entities/Group';
import { rootGroup } from 'entities/RootGroup';

import styles from './styles/RecentMessages.css';

class RecentMessages extends React.Component {
  state = {
    selectedChat: RecentMessages.getSelectedChat(),
  };

  static childContextTypes = {
    chatSelectionAction: React.PropTypes.string,
    group: React.PropTypes.instanceOf(Group),
  };

  static getSelectedChat(): ?Chat {
    return ChatStore.getCurrentChat() || ChatStore.getChats(rootGroup).first();
  }

  static getStores() {
    return [ChatStore];
  }

  static calculateState() {
    return {
      selectedChat: RecentMessages.getSelectedChat(),
    };
  }

  getChildContext() {
    return {
      chatSelectionAction: 'store',
      group: rootGroup,
    };
  }

  render() {
    if (!this.state.selectedChat) {
      return <LoadingIndicator />;
    }

    const chatId = this.state.selectedChat.id;
    return (
      <View
        full
        data-test-selector="recent-chatlist"
        className={styles.this}>
        <ChatList
          className={styles.sidebar}
          selectedChatId={chatId}
          group={rootGroup}
          unifiedView
          headerText="Recent"
        />
        <div className={styles.wrap}>
          <div className={styles.content}>
            <ConversationView params={{ chatId }} />
          </div>
        </div>
      </View>
    );
  }
}

export default Container.create(RecentMessages);



// WEBPACK FOOTER //
// ./src/groups/components/RecentMessages.jsx